module.exports = __webpack_public_path__ + "img/applicationConstruction-szls.ae52ba90.png";